<!--
 * guideKey 必传，识别新手引导所在组件
 * value 单个新手引导不需要传，多个新手引导使用vuex控制
 * isAutoRun 必传，单个新手引导true 多个false
 -->
<template>
  <div class="guide">
    <div
      v-show="isNew"
      ref="guide"
      class="guide-content"
      :style="{top: guideTop + 'px',width: guideWidth + 'px',left: guideLeft + 'px'}"
    >
      <!-- 三角 -->
      <span
        ref="rec"
        class="rec"
        :style="{left: left + 'px'}"
      />
      <span class="guide-text">{{ $t(guideText) }}</span>
    </div>
    <div
      ref="replace"
      class="replace"
      @click="closeGuide"
    >
      <slot />
    </div>
  </div>
</template>
<script>
/*
 * @Author: lisiyi
 * @Date: 2019-12-26 16:54
 * @Last Modified by: lisiyi
 * @Last Modified time: 2019-12-26 16:54
 */
import _$ from 'js/api/getdata'

export default {
  props: {
    guideText: { // 新手引导文本
      type: String,
      default: '选出想连续查看的文件类型',
    },
    guideKey: { // 必须传！！！！！！
      type: String,
      default: '',
    },
    value: { // 多新手引导使用  v-model绑定
      type: Boolean,
      default: false,
    },
    isAutoRun: { // 组件内调用接口为true 组件外调用false  多个新手引导必传false
      type: Boolean,
      default: true,
    },
    guideWidth: { // 宽度
      type: Number,
      default: 170,
    },
  },
  data() {
    return {
      isNew: false, // 显隐
      guideLeft: '', // 提示框定位
      left: '', // 三角定位
      guideTop: '', // 提示框定位
    }
  },
  watch: {
    isNew(n) {
      this.setPosition()
      this.$emit('input', n)
    },
    value(n) {
      this.isNew = n
    },
  },
  mounted() {
    if (this.isNew) {
      this.setPosition()
    }
  },
  updated() {
    this.setPosition()
  },
  created() {
    this.isNew = this.value
    if (this.isAutoRun) {
      this.getState()
    }
  },
  methods: {
    /**
        * 获取新手引导状态
        */
    getState() {
      const getBubbleData = {
        bubbleType: 'preview',
      }
      _$.getData('getFeatureGuide', getBubbleData)
        .then((res) => {
          // 置state状态
          // 为空，是第一次，所有引导都需要出现，直接置为false
          if (Object.keys(res.data).length !== 0) {
            this.isNew = false
          } else {
            this.isNew = true
          }
        }, () => {
          // 接口坏掉时候状态全修改
          this.isNew = false
        })
    },
    /**
        * 关闭新手引导
        * @param bubbleType 气泡信息类型front-前台；mc-管理控制台；all-全部
        * @param bubbleContent 气泡引导信息,前端自定义
        */
    closeGuide() {
      if (this.isNew) { // 单个新手引导
        const { previewBubbleContent } = JSON.parse(this.$store.state.guideInfo) // 取出存入localStorage的bubble信息
        const newbubbleContent = JSON.parse(previewBubbleContent) || {}
        newbubbleContent[this.guideKey] = false // 增加当前需要关闭的buggle类型
        const setFeatureGuideData = {
          bubbleType: 'preview',
          bubbleContent: JSON.stringify(newbubbleContent),
        }
        _$.getData('setFeatureGuide', setFeatureGuideData)
          .then(({ data }) => {
            this.$store.commit('SET_GUIDE_INFO', JSON.stringify(data))
            this.isNew = false
            if (!this.isAutoRun) {
              this.$store.commit('GET_AFTER_GUIDE', this.guideKey)
            }
          })
      }
    },
    setPosition() {
      this.$nextTick(() => {
        this.left = (this.$refs.guide.offsetWidth - this.$refs.rec.offsetWidth) / 2 // tips定位
        this.guideTop = -(this.$refs.guide.offsetHeight + this.$refs.rec.offsetHeight / 2)
        this.guideLeft = -(((this.guideWidth - this.$slots.default[0].elm.offsetWidth) / 2) + 10) // 定位
      })
    },
  },
}
</script>
<style lang="less" scoped>
.guide{
  display: inline-block;
  position: relative;
}
.guide-content{
  padding: 10px;
  background-color: #0a64fa;
  position: absolute;
  left: 0;
}
.rec{
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  border: 8px solid #0A64FA;
  bottom: -8px;
  transform: rotate(45deg);
}
.guide-text{
  color: white;
  display: block;
  line-height: 24px;
  font-size: 14px;
}
</style>
